module.exports = __webpack_public_path__ + "media/images/landings/promotion_4/ogp-e98423150b86d31595b72928b5faab8c.jpg";